import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Input } from 'reactstrap'
import { ALL_USERS_QUERY } from '../../graphql'

const ALL_USERS = gql(ALL_USERS_QUERY)

export default function UserSelect(props) {
  console.log('UserSelect rendered value: ', props)

  const { value, handleChange, firstItem = 'All Users' } = props
  const { loading, error, data } = useQuery(ALL_USERS, { fetchPolicy: 'cache-first' })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return error.message
  }

  return (
    <Input type="select" name="userId" id="user" bsSize="sm" value={value} onChange={handleChange}>
      <option key={-1} value="">{firstItem}</option>
      {data.allUsers.map(user => (
        <option key={user.id} value={user.id}>
          {user.name}
        </option>
      ))}
    </Input>
  )
}